import styled, { css } from 'styled-components';
import {
  ButtonGroup,
  RadioGroup,
  Typography,
  Menu,
  Popover,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import Button from 'components/mui/Button';
import SwitchChip from 'components/mui/SwitchChip';
import KeyboardDateRangePicker from 'components/mui/KeyboardDateRangePicker';
import Dialog from 'components/mui/Dialog';

export default {
  TimeframeWrapper: styled.div`
    display: flex;
    position: relative;
    flex: 1;
    ${({ theme }) => css`
      ${theme.breakpoints.up('sm')} {
        max-width: 360px;
      }
      ${theme.breakpoints.up('md')} {
        flex: initial;
      }
    `}
  `,

  TimeframeLabel: styled(Typography)`
    text-transform: unset;
    margin-bottom: 20px;
    display: inline-block;

    ${({ theme }) => css`
      font-family: ${theme.typography.fontFamily};

      ${theme.breakpoints.up('md')} {
        font-size: 12px;
        text-transform: uppercase;
        margin-right: 20px;
        margin-bottom: 0;
        font-family: ${theme.typography.fontFamilyAccent};
      }
    `}
  `,

  TimeframeTimezone: styled(Typography)(
    () => css`
      font-size: 11px;
      display: flex;
      margin-top: -6px;
      opacity: 0.8;
    `,
  ),

  TimeframeButtonGroup: styled(ButtonGroup)``,

  TimeframeButton: styled(Button)`
    border-width: 1px;
    height: 30px;
    padding: 7px 14px 8px;
    background-color: #fff;

    & .MuiButton-endIcon {
      margin-top: 2px;
    }

    ${({ $selected, theme }) => css`
      border-color: ${theme.palette.text.hint};
      font: 400 0.75rem ${theme.typography.fontFamily};

      &:hover {
        border-width: 1px;
        border-right-color: ${theme.palette.dark.main};
        z-index: 1;
      }

      &.Timeframe-select {
        min-width: 190px;
        justify-content: space-between;
      }

      ${$selected &&
      css`
        color: ${theme.palette.dark.contrastText};
        background-color: ${theme.palette.dark.main};

        &:hover {
          background-color: ${theme.palette.dark.light};
        }
      `}
    `}
  `,

  Menu: styled(Menu)`
    & .MuiList-padding {
      padding-top: 0;
      padding-bottom: 0;
    }
    & .MuiMenu-paper {
      min-width: 190px;
      border-radius: 0;
    }

    & .MuiMenuItem-root {
      font-size: 0.75rem;
      padding-top: 10px;
      padding-bottom: 10px;

      &.Mui-selected {
        background-color: ${({ theme }) =>
          alpha(theme.palette.primary.light, 0.5)};
      }
    }
  `,

  DatePopover: styled(Popover)`
    & .MuiPopover-paper {
      background-color: transparent;
      box-shadow: none;
      margin-top: 1.5rem;
    }
  `,

  TimeframeDatepicker: styled(KeyboardDateRangePicker)`
    ${({ theme }) => css`
      ${theme.breakpoints.up('md')} {
        position: relative;
        border-radius: 4px;
        z-index: 10;
        background-color: #fff;
        box-shadow: ${theme.shadows[1]};

        &:before,
        &:after {
          content: '';
          width: 0;
          height: 0;
          position: absolute;
          top: -24px;
          right: 60px;
          border: 10px solid transparent;
          border-bottom: 14px solid #f1e9e9;
        }

        &:after {
          top: -21px;
          right: 61px;
          border: 9px solid transparent;
          border-bottom: 13px solid #fff;
        }
      }
    `}
  `,

  Dialog: styled(Dialog)``,

  DialogContent: styled(DialogContent)``,

  DialogActions: styled(DialogActions)`
    padding: 24px;
    border-top: 1px solid #b4b4b4;
  `,

  TimeframeRadioGroup: styled(RadioGroup)``,

  TimeframeSwitchItem: styled(SwitchChip)`
    margin-bottom: 16px;

    &.MuiSwitchChip-root {
      &.Mui-checked {
        ${({ theme }) => css`
          background-color: ${theme.palette.success.light};
        `}
      }
    }
  `,

  TimeframeButtonMobile: styled(Button)`
    justify-content: space-between;
    text-transform: uppercase;
    font-size: 0.75rem;
    background-color: #fff;
    height: 42px;

    ${({ theme }) => css`
      color: ${theme.palette.text.primary};
      border: 1px solid ${theme.palette.dark.main};
      font-family: ${theme.typography.fontFamily};
      border-radius: 0;
    `}

    &:hover {
      border-width: 1px;
    }

    & .MuiButton-endIcon {
      ${({ theme }) => css`
        color: ${theme.palette.dark.main};
      `}
    }
  `,
};
